import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getWithDrawals = (params) => {
    return axios.get(`${backendHost}/api/admin/withdrawal/list`, {params});
};

export {
    getWithDrawals
}